import React, { useState } from 'react';
import SectionTitle from '../../yourProperties/Title';
import useTranslate from '../../../../customHooks/useTranslate';
import Card from '../../../../muiComponents/Card';
import IconButton from '../../../../muiComponents/IconButton';

const MainInformation = props => {
    const { notes } = props;
    const title = useTranslate('notes');

    const [isVisibleSection, setIsVisibleSection] = useState(true);

    return (
        <section className='booking__section'>
            <div
                className={`flex flex-between flex-align-baseline ${
                    !isVisibleSection ? 'border-color-bottom' : ''
                }`}
            >
                <SectionTitle text={title} />
                <IconButton
                    iconName={isVisibleSection ? 'ExpandLess' : 'ExpandMore'}
                    onClick={() => setIsVisibleSection(!isVisibleSection)}
                />
            </div>
            {isVisibleSection ? <Card className='padding20'>{notes}</Card> : ''}
        </section>
    );
};

export default MainInformation;
